const MENU = {
    CHANGE_CURRENT_SLIDE: 'CHANGE_CURRENT_SLIDE'
}

export {MENU}